import React, { Fragment } from "react"

import Layout from "layout"
import HomeBanner from "components/StaticPages/Home/HomeBanner"
import PrivateRoute from "../components/Layout/PrivateRoute"

const IndexPage = () => {
  return (
    <Fragment>
      <Layout
        display={{ helpCenterBanner: false, footer: true }}
        seoTitle="Foundever"
      >
        <HomeBanner />
      </Layout>
    </Fragment>
  )
}

export default IndexPage
